import { defineComponent as P, computed as S, createBlock as n, openBlock as t, resolveDynamicComponent as d, normalizeClass as p, unref as o, withCtx as m, createElementVNode as c, mergeProps as v, createElementBlock as V, createCommentVNode as H, renderSlot as I, createTextVNode as R, toDisplayString as z } from "vue";
import f from "./packages/core/dist/helpers/PassThrough.vue2.js";
import { useOUIAProps as A } from "./packages/core/dist/helpers/ouia.js";
import r from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table.js";
import E from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table-grid.js";
import b from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table-tree-view.js";
import u from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table-scrollable.js";
import { toCamelCase as y } from "./packages/core/dist/util.js";
import { provideChildrenTracker as N } from "@vue-patternfly/core";
import { TableTrKey as $ } from "./common.js";
const D = ["role"], G = { key: 0 }, Q = /* @__PURE__ */ P({
  name: "PfTable",
  inheritAttrs: !1,
  __name: "Table",
  props: {
    compact: { type: Boolean },
    noBorders: { type: Boolean },
    gridBreakPoint: { default: "grid-md" },
    stickyHeader: { type: Boolean },
    treeTable: { type: Boolean },
    nested: { type: Boolean },
    striped: { type: Boolean },
    expandable: { type: Boolean },
    nestedHeaderColumnSpans: {},
    selectableRowCaptionText: {},
    role: { default: "grid" },
    horizontalScroll: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(B) {
    var s, l;
    const a = B, k = A({ id: a.ouiaId, safe: a.ouiaSafe }), T = (s = E.modifiers) == null ? void 0 : s[y(a.gridBreakPoint || "").replace(/-?2xl/, "_2xl")], g = `treeView${a.gridBreakPoint.charAt(0).toUpperCase() + a.gridBreakPoint.slice(1)}`, w = (l = b.modifiers) == null ? void 0 : l[y(g || "").replace(/-?2xl/, "_2xl")], C = N($), h = S(() => C.some((e) => e.selectable));
    return (e, i) => (t(), n(d(e.stickyHeader ? "div" : f), {
      class: p(o(u).scrollOuterWrapper)
    }, {
      default: m(() => [
        (t(), n(d(e.horizontalScroll ? "div" : f), {
          class: p(o(u).scrollInnerWrapper)
        }, {
          default: m(() => [
            c("table", v({ ...o(k), ...e.$attrs }, {
              role: e.treeTable ? "treegrid" : e.role,
              class: [o(r).table, e.treeTable ? o(w) : o(T), {
                [o(r).modifiers.compact]: e.compact,
                [o(r).modifiers.noBorderRows]: e.noBorders,
                [o(r).modifiers.stickyHeader]: e.stickyHeader,
                [o(b).modifiers.treeView]: e.treeTable,
                [o(r).modifiers.striped]: e.striped,
                [o(r).modifiers.expandable]: e.expandable,
                "pf-m-nested": e.nested
              }]
            }), [
              h.value ? (t(), V("caption", G, [
                R(z(e.selectableRowCaptionText) + " ", 1),
                i[0] || (i[0] = c("div", { class: "pf-v6-screen-reader" }, " This table has selectable rows. It can be navigated by row using tab, and each row can be selected using space or enter. ", -1))
              ])) : H("", !0),
              I(e.$slots, "default")
            ], 16, D)
          ]),
          _: 3
        }, 8, ["class"]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  Q as default
};
